module.exports = __webpack_public_path__ + "static/media/maf_recomendaciones_transportistas.44cf4ae4.pdf";